import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/mail.svg'
import _imports_1 from '@/assets/img/phone.svg'
import _imports_2 from '@/assets/img/location.svg'


const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "contactBlock" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "titleContainer" }
const _hoisted_7 = { class: "pageTitle" }
const _hoisted_8 = { class: "pageSubtitle" }
const _hoisted_9 = { class: "contentContainer" }
const _hoisted_10 = { class: "timingBlock" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "data" }
const _hoisted_13 = { class: "contactsList" }
const _hoisted_14 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", { href: "mailto:th@moneyspace.net" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: "mail",
      class: "icon"
    }),
    /*#__PURE__*/_createVNode("span", { class: "data" }, "th@moneyspace.net")
  ])
], -1)
const _hoisted_15 = { href: "tel:021183082" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "phone",
  class: "icon"
}, null, -1)
const _hoisted_17 = { class: "data" }
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "mapWrapper" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "mapBlock" }, [
  /*#__PURE__*/_createVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.701451860718!2d100.56020092586489!3d13.73651629764571!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f8b1020ecb7%3A0xb29a5e00b604a7d3!2sP23%20Tower!5e0!3m2!1svi!2s!4v1716957027415!5m2!1svi!2s",
    frameborder: "0",
    style: {"border":"0"},
    allowfullscreen: "",
    sandbox: "allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox",
    referrerpolicy: "no-referrer-when-downgrade",
    "aria-hidden": "false",
    tabindex: "0"
  })
], -1)
const _hoisted_21 = { class: "locationBlock" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "location",
  class: "icon"
}, null, -1)
const _hoisted_24 = { class: "data" }
const _hoisted_25 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("pageTitle")), 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t("pageSubtitle")), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t("title")), 1),
                _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("data")), 1)
              ]),
              _createVNode("ul", _hoisted_13, [
                _hoisted_14,
                _createVNode("li", null, [
                  _createVNode("a", _hoisted_15, [
                    _hoisted_16,
                    _createVNode("span", _hoisted_17, _toDisplayString(_ctx.t("contactsList[1]")), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t("locationBlock.title")), 1)
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("p", null, _toDisplayString(_ctx.t("locationBlock.content")), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}